import { useTranslation } from "react-i18next";

export function ArchiveNotice() {
  const { t } = useTranslation();

  return (
    <p className="text-center text-sm text-muted-foreground">
      {t("archive.notice")}{" "}
      <a
        href="https://chat.nyteca.ch"
        className="text-primary-text underline underline-offset-4"
      >
        {t("archive.newChat")}
      </a>
    </p>
  );
}
